import Vue from 'vue'
import Vuex from 'vuex'
import { stat } from 'fs';

Vue.use(Vuex)

export const store = new Vuex.Store({
    state: {
        line_id: '-1',
        co: '-1'
    },
    mutations: {
        setLineId(state, tmp){state.line_id = tmp},
        setCo(state, tmp){state.co = tmp},
    },
    getters: {
        line_id: state => state.line_id,
        co: state => state.co,
    }
})
